import { Component, OnInit, Input, HostListener } from '@angular/core';
import * as d3 from 'd3';
@Component({
    selector: 'app-line-chart',
    templateUrl: './line-chart.component.html'
})
export class LineChartComponent implements OnInit {
    @Input() GraphData: any;
    viewData = [];
    barnumber = 5;
    currentPage = 1;
    totalPage: number;
    constructor() { }
    ngOnInit(): void {
    }
    ngAfterViewInit() {
        var result = this.SortData(this.GraphData.chartData);
        this.LoadLineChart(result, this.GraphData.chartContainerName);
    }
    LoadLineChart(lineData, chartContainer) {
        let that = this;
        const line_stroke_width = 2;
        d3.select(chartContainer).html("");
        let containerIdWithoutHash = chartContainer.split('#')[1];
        //console.log(lineData);
        this.totalPage = Math.ceil(lineData.length / this.barnumber);
        this.viewData = lineData.slice((this.currentPage - 1) * this.barnumber, this.currentPage * this.barnumber);
        // set the dimensions and margins of the graph
        var svgWidth = d3.select(chartContainer).node().offsetWidth, svgHeight = 350;
        var margin = { top: 20, right: 10, bottom: 50, left: 75 };
        var width = svgWidth - margin.left - margin.right;
        var height = svgHeight - margin.top - margin.bottom;

        //Adding SVG element inside Container
        //var svg = d3.select(chartContainer).append("div")
        //    .classed("svg-container", true) //container class to make it responsive
        //    .append("svg")
        //    //responsive SVG needs these 2 attributes and no width and height attr
        //    .attr("preserveAspectRatio", "xMinYMin meet")
        //    .attr("viewBox", "0 0 " + svgWidth +" " + svgHeight)
        //    //class to make it responsive
        //    .classed("svg-content-responsive", true); 

        var svg = d3.select(chartContainer).append("svg")
            //.attr("width", svgWidth)
            //.attr("height", svgHeight);
            .attr("preserveAspectRatio", "xMinYMin meet")
            .attr("viewBox", "0 0 " + svgWidth + " " + svgHeight);

        //Create group element inside svg element to draw chart
        var chart = svg.append("g")
            .attr("transform",
                "translate(" + margin.left + "," + margin.top + ")"
            );
        var tempElement = svg.append('text').attr('id', 'temp_' + containerIdWithoutHash);
        let maxDataY = d3.max(this.viewData, function (d) {
            return parseInt(d.sankeyData);
        })
        var yRange = d3.scaleLinear().range([height, 0]);
        var yScale = yRange.domain([0, maxDataY]);
        let yTicks = that.GenerateTicks(yRange, maxDataY);
        maxDataY = yTicks[yTicks.length - 1];
        yScale = yRange.domain([0, maxDataY]);
        //var tickYAxis = (Math.round((Math.round(Math.round(d3.max(this.viewData, function (d) { return parseInt(d.sankeyData); }) / 5) / 10) * 10) / 50) * 50) + 50;

        let yAxis = chart.append('g').attr("class", "yaxis").call(d3.axisLeft(yScale)
            //.tickFormat(d => (d >= 1000 ? ((d / 1000).toFixed(1) + 'k') : d))
            .tickFormat(d => {
                return (d > 1 || d == 0) ? `${d3.format("~s")(d)}` : d.toFixed(1);
            })
            .tickSize(-width)
            .tickPadding(10)
            .tickValues(that.GenerateTicks(yRange, maxDataY)));
        //.tickValues([...new Set(yRange.ticks(4))]));
        // .tickValues(d3.range(0, d3.max(lineData, function (d) { return parseInt(d.sankeyData); }),
        //     tickYAxis)));
        yAxis
            .selectAll('line')
            .attr('stroke', '#e6e6e6')
        yAxis
            .select('.domain')
            .style('opacity', 0);

        var xScale = d3.scalePoint().range([0, width]).domain(this.viewData.map((d) => d.sankeyXData)).padding(1);

        let xAxis = chart.append('g')
            .attr("transform", "translate(0," + height + ")")
            .attr("class", "xaxis")
            .call(d3.axisBottom(xScale)
                .tickPadding(5)
                .tickSize(10, 9, 0)
                //.tickValues(lineData.map((d) => d.sankeyXData))
            );
        xAxis
            .selectAll('line')
            .attr('stroke', '#e6e6e6')
        xAxis
            .select('.domain')
            .style('opacity', 0);
        //Show the x axis labels in 45 degree and show only alternate labels in case if more than 20 x axis labels are there
        d3.select(chartContainer).selectAll('.xaxis text')
            //.attr("x", -12)
            //.style("text-anchor", lineData.length > 6 ? "end" : "")
            //.style("text-anchor", "end")
            .style("color", "#015b63")
            .style("cursor", "default")
            .style("font-size", "10px")
            .style("font-family", "Graphik Regular")
            .style("fill", "#015b63")
            .style("text-anchor", "middle")
            .style("opacity", "1")
            .attr("class", function (d, i) { if (that.viewData.length > 20 && i > 0 && i % 2 != 0) { d3.select(this).remove(); } })
            //.attr("transform", lineData.length > 6 ? "rotate(-45)" : "");
            //.attr("transform", "rotate(-45)")
            .text(d => {
                if (d.length > 8) {
                    d = d.substring(0, 7) + '...';
                }
                return d;
            })
            .append('title')
            .text(d => d);
        //.text(d => d.length > 8 ? d : null);

        //Hide the x axis ticks if alternate labels are shown when more than 20 labels
        d3.select(chartContainer).selectAll('.xaxis ticks')
            .attr("class", function (d, i) { if (that.viewData.length > 20 && i % 2 != 0) { d3.select(this).remove(); } });
        let yAxisLabel = this.displayYAxislabel(this.viewData[0].XAxis);
        tempElement.text(yAxisLabel);
        let yAxisLabelWidth = tempElement.node().getBBox().width;
        tempElement.style('display', 'none');
        //Y Axis legend
        svg.append('text')
            .attr('x', -(svgHeight / 2 - yAxisLabelWidth / 2))//-(height / 2))
            //.attr('y', (margin.left / 3))
            .attr('y', 10)
            .attr("dy", "1em")
            .attr("font-family", "Graphik Regular")
            .attr('transform', 'rotate(-90)')
            .style('fill', '#015b63')
            .style('font-size', '12px')
            .style('font-weight', 'bold')
            .attr('text-anchor', 'middle')
            .text(yAxisLabel);

        //X Axis legend
        // svg.append("line")
        //     .attr("x1", (svgWidth / 2) - 25)
        //     .attr("y1", svgHeight - margin.top - 5)
        //     .attr("x2", (svgWidth / 2) - 7)
        //     .attr("y2", svgHeight - margin.top - 5)
        //     .attr("fill", "none")
        //     .attr("stroke", "#A260B7")
        //     .attr("stroke-width", 2);

        // svg.append("rect")
        //     .attr("x", (svgWidth / 2) - 20)
        //     .attr("y", svgHeight - margin.top - 9)
        //     .attr('height', 8)
        //     .attr('width', 8)
        //     .attr('rx', 4)
        //     .attr('ry', 4)
        //     .style('fill', '#A260B7')
        //     .style('cursor', 'default')
        //     .style('top', margin.top)
        //     .attr('text-anchor', 'end');

        // svg.append('text')
        //     .attr('x', (svgWidth / 2))
        //     .attr('y', svgHeight - margin.top)
        //     .style('fill', '#015b63')
        //     .style("font-family", "Graphik Medium")
        //     .style('cursor', 'pointer')
        //     .style('font-size', '12px')
        //     .style('font-weight', 'bold')
        //     .attr('text-anchor', 'start')
        //     .text(this.viewData[0].XAxis);

        //Tooltip
        const tooltip = d3.select(chartContainer)
            .append("div")
            .attr("class", "tooltip-line")
            .style("opacity", 0);

        // define the line
        var line = d3.line()
            .x(function (d) { return xScale(d.sankeyXData); }) // set the x values for the line generator
            .y(function (d) { return yScale(d.sankeyData); }) // set the y values for the line generator 
            //.curve(d3.curveCatmullRom.alpha(1));
            .curve(d3.curveMonotoneX);
        //Binds data to the line 
        chart.append('g')
            .append("path")
            .datum(this.viewData)
            .attr('class', 'line')
            .attr('d', line)
            .attr("fill", "none")
            .attr("stroke-width", line_stroke_width)
            .attr("opacity", "1")
            .attr("stroke", '#A260B7')
        //append text for each data point
        chart
            .selectAll(".linetext")
            .data(this.viewData)
            .enter().append("text") // Uses the enter().append() method
            .attr("class", "linetext") // Assign a class for styling
            .attr("x", function (d) { return xScale(d.sankeyXData) + 10 })
            .attr("y", function (d) { return yScale(d.sankeyData) - 1 })
            .attr('fill', '#000')
            .style('font-size', '10px')
            .text(d => that.CleanNumber(d.sankeyData))
        //append dots for each data to hover
        chart
            .selectAll(".dot")
            .data(this.viewData)
            .enter().append("circle") // Uses the enter().append() method
            .attr("class", "dot") // Assign a class for styling
            .attr("cx", function (d) { return xScale(d.sankeyXData) })
            .attr("cy", function (d) { return yScale(d.sankeyData) })
            .attr("r", 3.5)
            .attr('fill', '#A260B7')
            .on('mouseenter', function (actual, i) {
                chart
                    .append("circle")
                    .attr("r", 8)
                    .attr("class", "dot")
                    .attr('id', 'dotFocus')
                    .attr('fill', '#A260B7')
                    .attr("cx", xScale(d3.select(this).data()[0].sankeyXData))
                    .attr("cy", yScale(parseInt(d3.select(this).data()[0].sankeyData)))
                    .style('pointer-events', 'none')
                    .style('opacity', 0.4);

                d3.select(this).attr("r", 5);
                d3.select(this).style("stroke", 'rgb(255, 255, 255)');
                d3.select(this).style('stroke-width', 1);

                //show tooltip
                tooltip.transition().duration(50).style('opacity', 0.9);
                tooltip.html(d3.select(this).data()[0].sankeyXData + '<br> #' + that.viewData[0].XAxis + ' : ' + parseInt(d3.select(this).data()[0].sankeyData))
                    .style('left', (d3.event.offsetX - 55) + 'px')
                    .style('top', (d3.event.offsetY) + 15 + 'px')
                    .style("display", "block");
                //.style('top', d3.event.target.getBoundingClientRect().top + 'px');
            })
            .on("mouseleave", function (actual, i) {

                d3.select(this).attr("r", 3.5);
                d3.select(this).style("stroke", 'rgb(169, 167, 251)');
                d3.select(this).style('stroke-width', 1);

                //hide tooltip
                tooltip.transition().duration(800).style('opacity', 0);
                d3.select('#dotFocus').remove();
            });
        //Pagination
        if (this.totalPage > 1) {
            svg.append("path")
                .attr("d", "M3.875,3.095,6.8.163a.551.551,0,0,1,.782,0,.558.558,0,0,1,0,.784L4.267,4.269a.553.553,0,0,1-.763.016L.161.949A.554.554,0,0,1,.943.165Z")
                .attr('transform', "translate(" + margin.left + ", " + (svgHeight - margin.bottom + 19) + ") rotate(90)")     //19 (Because tickpadding=8 + margin from insertLineBreak=10 + 1(MagicNumber))
                .attr('class', 'leftTriangle')
                .attr('fill', '#000')
                .attr('stroke', '#000')
                .attr('stroke-width', 2)
                .attr("opacity", 0.7)
                .attr('cursor', 'pointer')
                .on('click', function (d) {
                    if (that.currentPage != 1) {
                        that.currentPage--;
                        that.prevPage();
                    }
                })
            svg.append("path")
                .attr("d", "M3.875,1.335,6.8,4.267a.551.551,0,0,0,.782,0,.558.558,0,0,0,0-.784L4.267.161A.553.553,0,0,0,3.5.145L.161,3.481a.554.554,0,0,0,.782.784Z")
                .attr('transform', "translate(" + (svgWidth - margin.right - 1) + ", " + (svgHeight - margin.bottom + 19) + ") rotate(90)")
                .attr('class', 'rightTriangle')
                .attr('fill', '#000')
                .attr('stroke', '#000')
                .attr('stroke-width', 2)
                .attr("opacity", 0.7)
                .style('cursor', 'pointer')
                .on('click', function (d) {
                    if (that.currentPage < that.totalPage) {
                        that.currentPage++;
                        that.nextPage();
                    }
                })

            if (that.currentPage == 1) {
                svg.select(".leftTriangle").attr('fill', '#cccccc').attr('stroke', '#cccccc').attr('stroke-width', 2).attr("opacity", 0.7).style('cursor', 'default');
            }
            if (that.currentPage == that.totalPage) {
                svg.select(".rightTriangle").attr('fill', '#cccccc').attr('stroke', '#cccccc').attr('stroke-width', 2).attr("opacity", 0.7).style('cursor', 'default');
            }
        }
    }
    /*generic way */
    nextPage() {
        var result = this.SortData(this.GraphData.chartData);
        this.LoadLineChart(result, this.GraphData.chartContainerName);
    }

    prevPage() {
        var result = this.SortData(this.GraphData.chartData);
        this.LoadLineChart(result, this.GraphData.chartContainerName);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        var result = this.SortData(this.GraphData.chartData);
        this.LoadLineChart(result, this.GraphData.chartContainerName);
    }
    displayYAxislabel(name) {
        let res = name;
        switch (name) {
            case 'TAT':
                res = 'TAT (Median Hrs)';
                break;
            case 'TicketCount':
                res = 'TicketCount';
                break;
            case 'TicketAge':
                res = 'TicketAge (In days)';
                break;
            default:
                break;
        }
        return res;
    }
    CleanNumber(str) {
        //str = str.toFixed(2);
        if (str >= 1)
            str = d3.format("~s")(str);
        else
            str = str;
        if (!this.isNumeric(str)) {
            let lastLetter = str.substring(str.length - 1);
            str = str.substring(0, str.length - 1);
            if (str.indexOf('.'))
                str = parseFloat(str).toFixed(1).toString() + lastLetter;
        }
        return str;
    }
    isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
    SortData(inputData) {
        let result = [];
        let that = this;
        inputData.forEach(element => {
            result.push({ sankeyXData: element.sankeyXData, sankeyData: element.sankeyData, XAxis: element.XAxis, date: that.GetDate(element.sankeyXData) });
        });
        return result.sort((c, d) => c.date - d.date);
    }
    FindMonthIndex(month) {
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return (months.findIndex(x => x == month) + 1);
    }
    GetDate(data) {
        var month = this.FindMonthIndex(data.split("'")[0]);
        if (month > 0) {
            var year = parseInt('20' + data.split("'")[1]);
            return new Date(year, month, 1, 0, 0, 0, 0);
        }
        return '';
    }
    GenerateTicks(axisRange, maxData) {
        let tickArray = axisRange.ticks(4);
        if (tickArray[tickArray.length - 1] < maxData) {
            let diff = (tickArray[tickArray.length - 1]) - (tickArray[tickArray.length - 2]); // Add the difference to create new tick
            tickArray.push(tickArray[tickArray.length - 1] + diff);
        }
        return tickArray;
    }
}
